import { render, staticRenderFns } from "./ProductTechnicalDetails.vue?vue&type=template&id=1248a0a1&"
import script from "./ProductTechnicalDetails.vue?vue&type=script&lang=js&"
export * from "./ProductTechnicalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports